var _path, _g, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgElectronicInvoice(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9746 2.11523C16.5958 2.11523 17.0995 2.61905 17.0996 3.24023V6.05273C17.0996 6.67404 16.5959 7.17773 15.9746 7.17773H2.02539C1.40408 7.17773 0.900391 6.67404 0.900391 6.05273V3.24023C0.90054 2.61905 1.40417 2.11523 2.02539 2.11523H15.9746ZM2.96973 4.24219C2.72152 4.24237 2.52076 4.44321 2.52051 4.69141V5.81641C2.52051 6.06482 2.72136 6.26642 2.96973 6.2666H15.2324C15.4809 6.26655 15.6826 6.0649 15.6826 5.81641V4.69141C15.6824 4.44313 15.4807 4.24224 15.2324 4.24219H2.96973Z",
    fill: "url(#paint0_linear_12563_8012)"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: -1.47379,
    y: 0.45028,
    width: 21.1495,
    height: 21.0931
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2.25px)",
      clipPath: "url(#bgblur_0_12563_8012_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_12563_8012)",
    "data-figma-bg-blur-radius": 4.49992
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.02612 6.07517C3.02612 5.45386 3.52979 4.9502 4.1511 4.9502H14.0509C14.6722 4.9502 15.1759 5.45387 15.1759 6.07517V16.2168C15.1759 16.6283 14.7485 16.9005 14.3755 16.7265L12.3764 15.7936C12.2256 15.7232 12.0514 15.7232 11.9006 15.7936L9.33502 16.9908C9.18646 17.0601 9.01506 17.0612 8.86566 16.9937L6.2018 15.7907C6.05005 15.7222 5.87573 15.7244 5.72577 15.7968L3.83314 16.7104C3.45965 16.8907 3.02612 16.6186 3.02612 16.2038V6.07517Z",
    fill: "#477FFF",
    fillOpacity: 0.35
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.87331 8.88651C8.87331 8.50207 8.56167 8.19043 8.17723 8.19043H5.64603L5.55872 8.19586C5.21549 8.23881 4.94995 8.53165 4.94995 8.88651C4.94995 9.27095 5.2616 9.58259 5.64603 9.58259H8.17723L8.26455 9.57716C8.60777 9.53421 8.87331 9.24137 8.87331 8.88651ZM13.092 11.4177C13.092 11.0333 12.7804 10.7216 12.3959 10.7216H5.64603L5.55872 10.7271C5.21549 10.77 4.94995 11.0628 4.94995 11.4177C4.94995 11.8022 5.2616 12.1138 5.64603 12.1138H12.3959L12.4832 12.1083C12.8265 12.0654 13.092 11.7726 13.092 11.4177Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_12563_8012",
    x: -1.47379,
    y: 0.45028,
    width: 21.1495,
    height: 21.0931,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.224996
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.12498
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_12563_8012"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_12563_8012_clip_path",
    transform: "translate(1.47379 -0.45028)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.02612 6.07517C3.02612 5.45386 3.52979 4.9502 4.1511 4.9502H14.0509C14.6722 4.9502 15.1759 5.45387 15.1759 6.07517V16.2168C15.1759 16.6283 14.7485 16.9005 14.3755 16.7265L12.3764 15.7936C12.2256 15.7232 12.0514 15.7232 11.9006 15.7936L9.33502 16.9908C9.18646 17.0601 9.01506 17.0612 8.86566 16.9937L6.2018 15.7907C6.05005 15.7222 5.87573 15.7244 5.72577 15.7968L3.83314 16.7104C3.45965 16.8907 3.02612 16.6186 3.02612 16.2038V6.07517Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12563_8012",
    x1: 0.900391,
    y1: 4.64648,
    x2: 17.0996,
    y2: 4.64648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#477FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#477FFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectronicInvoice);
export default __webpack_public_path__ + "static/media/electronicInvoice.9fc11ae45cef41cdc5eb06c3691e0985.svg";
export { ForwardRef as ReactComponent };